export enum UserStatus {
  NEW = 'NEW',
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  REJECTED = 'REJECTED',
  DELETED = 'DELETED',
}

export const UserStatusLabel: Record<UserStatus, string> = {
  [UserStatus.NEW]: 'Новый',
  [UserStatus.ACTIVE]: 'Активен',
  [UserStatus.BLOCKED]: 'Заблокирован',
  [UserStatus.REJECTED]: 'Отказано в регистрации',
  [UserStatus.DELETED]: 'Удален',
};
